import React from 'react';


const HexText = (props) => (
  <div className="hextext">
    <h2>{props.title}</h2>
    <p>{props.description}</p>
  </div>
);

export default HexText;



// WEBPACK FOOTER //
// ./src/components/About/components/HexText/index.js